export default __webpack_public_path__ + "static/media/gallery-wip-emitter-body_06.cee70c35.jpg";